import { graphql } from 'gatsby';
import React from 'react';
import Masonry from 'react-masonry-css';
import { css } from '@emotion/react';
import { colors } from '../../primitives/colors';
import Container from '../../primitives/grid/container';
import Image, { CsAssetSize, getSizesProp } from '../../primitives/image';
import paddingDefault from '../../utils/padding-default';
import apCaseOnlyTitleTags from '../../utils/ap-case-only-title-tags';

const breakpointColumnsObj = {
    default: 3,
    700: 2,
    500: 1,
};

const styles = {
    header: css({
        marginBottom: '48px',
        textAlign: 'center',
    }),
    heading: css({
        fontSize: '42px',
    }),
    subheading: css({
        color: colors.primaryOrange,
    }),
};

const Gallery: React.FC<Queries.GalleryDataFragment> = (data) => {
    const { heading, subheading, images } = data;

    return (
        <section css={paddingDefault()}>
            <Container>
                {(heading || subheading) && (
                    <header css={styles.header}>
                        {heading && <h2 css={styles.heading}>{apCaseOnlyTitleTags(heading)}</h2>}
                        {subheading && (
                            <p css={styles.subheading}>{apCaseOnlyTitleTags(subheading)}</p>
                        )}
                    </header>
                )}
                {images && (
                    <Masonry
                        breakpointCols={breakpointColumnsObj}
                        className="my-masonry-grid"
                        columnClassName="my-masonry-grid-column"
                    >
                        {images.map((image) => {
                            if (!image) return null;
                            return (
                                <Image
                                    key={image.url}
                                    sizes={getSizesProp(CsAssetSize.THIRD_MAX_WIDTH)}
                                    image={image}
                                    alt={image.description || ''}
                                />
                            );
                        })}
                    </Masonry>
                )}
            </Container>
        </section>
    );
};

export const query = graphql`
  fragment GalleryData on CsGallery {
    ... on CsGallery {
      heading
      subheading
      images {
        filename
        title
        url
        description
        contentStackAsset(size: THIRD_MAX_WIDTH)
      }
    }
  }
`;

export default Gallery;
